// import IBModuleApi from "../../api/iuviBankingAPI";

export const getValidationMessages = async (appId: string) => {
  const data = [
    {
      widgets: ["Payments"],
      code: "100",
      ibmessage: "Message IB test 1",
      description: "Description value 1",
      technicaldescription: "Technical description value 1",
      language: "en",
      releaseversion: "2023.Q3",
      createdat: "2023-09-28T16:15:53.144Z",
      createdby: null,
      updatedat: "2023-09-28T16:14:39.848Z",
      updatedby: "Camilo"
    },
    {
      widgets: ["Tranfers"],
      code: "200",
      ibmessage: "Message IB test 2",
      description: "Description value 2",
      technicaldescription: "Technical description value 2",
      language: "en",
      releaseversion: "2023.Q4",
      createdat: "2023-09-28T16:15:53.144Z",
      createdby: null,
      updatedat: "2023-09-28T16:14:39.848Z",
      updatedby: "Camilo"
    }
  ]

  return data;
};

export const createValidationMessages = async (createInfo: any, appId: string) => {
  let data: any;
  return data;
};

export const updateValidationMessages = async (updateInfo: any, appId: string) => {
  let data: any;
  return data;
};

export const deleteValidationMessages = async (messageId: number) => {
  let data: any;
  return data;
};

export const exportValidationMessages = async (info: any) => {
  let data: any;
  return data;
};

export const importValidationMessages = async (info: any) => {
  let data: any;
  return data;
};
